import { useEffect } from 'react'
import { useNavigate } from 'react-router-dom'
import { NavBar } from 'shop/components'
import OrderPageLoader from 'shop/components/Loader/OrderPageLoader'
import { PAGE_ORDER } from 'shop/components/NavBar/utils'
import { useConsumerCart, useShop } from 'shop/hooks'
import { sendPurchaseTracking } from 'tracker/purchaseUtils'

type PurchasePageProps = {
  transactionId: string | undefined
}

const PurchasePage = ({ transactionId }: PurchasePageProps) => {
  const { customerId, partner } = useShop()
  const { getConsumerCart, cart } = useConsumerCart()

  const navigate = useNavigate()

  /** Get consumer cart on page load
   * TODO: Replace with consumer cart loader wrapper context
   */
  const fetchCart = async () => {
    return getConsumerCart().catch((error) => {
      console.error(error)
    })
  }

  useEffect(() => {
    if (!transactionId) return
    fetchCart().then((cart) => {
      if (!cart) return
      const trackAndNavigate = async () => {
        await sendPurchaseTracking({
          consumerCart: cart,
          transactionId,
          partnerName: partner?.name,
          customerId
        })
        // replace the history so users don't navigate back to it and track again.
        navigate(`/track/${transactionId}`, { replace: true })
      }
      trackAndNavigate()
    })
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [transactionId])

  return (
    <>
      <NavBar page={PAGE_ORDER} storeSlug={cart?.store?.slug} />
      <OrderPageLoader />
    </>
  )
}

export default PurchasePage
